import React, { useState } from 'react';
import { useVariantCopy } from './useVariantCopy';

// Variant landing-page FAQ (startviralgpt.com). Clone of components/FAQ.js —
// accordion only, no route links to rewire.
const FAQ = () => {
  const L = useVariantCopy();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(index === openIndex ? null : index);
  };

  const accordionData = [
    ...L.faq.items,
    ...(window.location.pathname.includes('/register') ? [] : L.faq.publicOnlyItems),
  ];

  return (
    <section id="faq" className="stripe-section stripe-section--white" style={{ paddingTop: '3rem', paddingBottom: '3rem' }}>
      <div className="mx-auto px-4 text-center stripe-container" style={{ maxWidth: '680px' }}>

        {/* Section Header */}
        <div style={{ marginBottom: '2rem' }}>
          <span className="text-instagram stripe-label">{L.faq.label}</span>
          <h2 className="mt-2 stripe-heading stripe-heading--lg">{L.faq.heading}</h2>
          <p className="mt-2 mx-auto stripe-body stripe-body--md stripe-body-narrow">
            {L.faq.sub}
          </p>
        </div>

        {accordionData.map((item, index) => (
          <div key={index} className="border-b border-gray-200">
            {/* Accordion Header */}
            <button
              onClick={() => toggleAccordion(index)}
              className="flex w-full items-center justify-between p-4 text-left text-gray-800 hover:bg-gray-50 focus:outline-none transition-colors duration-150"
              style={{ borderRadius: '8px' }}
            >
              <span className="font-medium">{item.title}</span>
              <svg
                className={`h-5 w-5 transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>

            {/* Accordion Content */}
            {openIndex === index && (
              <div className="p-4 text-gray-600 text-start stripe-body stripe-body--sm" style={{ lineHeight: 1.7 }}>
                {item.content}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
